import { GarageSearchModel } from "../../models/garage/garageSearch";
import * as GarageModels from "../../models/garage/garage";
import * as Models from "../../models/commonModels";

export class GetGarageDictionary {
  static readonly type = "[Garage] GetGarageDictionary";
  constructor(public Search: GarageSearchModel) {}
}

export class GetGarageList {
  static readonly type = "[Garage] GetGarageList";
  constructor(public search: GarageSearchModel) {}
}

export class GetGarageTypesDictionary {
  static readonly type = "[Garage] GetGarageTypesDictionary";
  constructor() {}
}

export class SetGarageSearch {
  static readonly type = "[Garage] SetGarageSearch";
  constructor(public Search: GarageSearchModel) {}
}

export class SetGarageListPage {
  static readonly type = "[Garage] SetGarageListPage";
  constructor(public Search: GarageSearchModel) {}
}

export class ResetGarageSearch {
  static readonly type = "[Garage] ResetGarageSearch";
  constructor() {}
}

export class Create {
  static readonly type = "[Garage] Insert";
  constructor(public Garage: Models.Request<GarageModels.GarageModel>) {}
}

export class Set {
  static readonly type = "[Garage] Set";
  constructor(public Garage: Models.Request<GarageModels.GarageModel>) {}
}

export class Get {
  static readonly type = "[Garage] Get";
  constructor(public Garage: Models.RequestModel) {}
}

export class GetPreview {
  static readonly type = "[Garage] Get Preview";
  constructor(public Garage: Models.RequestModel) { }
}

export class ResetSave {
  static readonly type = "[Garage] ResetSave";
  constructor() {}
}

export class SendGroupEmail {
  static readonly type = "[Garage] SendGroupEmail";
  constructor(public GroupEmail: GarageModels.GarageGroupEmailModel) {}
}

export class SendGroupMessage {
  static readonly type = "[Garage] SendGroupMessage";
  constructor(public GroupMessage: GarageModels.GarageGroupMessageModel) {}
}

export class GetGroupMessages {
  static readonly type = "[Garage] GetGroupMessages";
  constructor() {}
}

export class GetLastGroupMessage {
  static readonly type = "[Garage] GetLastGroupMessage";
  constructor() {}
}

export class GetGarageReportFiltered {
  static readonly type = "[Garage] GetGarageReportFiltered";
  constructor(public ReportName: string, public Search: GarageSearchModel) {}
}

export class GetGarageReportFilteredWithDeposites {
  static readonly type = "[Garage] GetGarageReportFilteredWithDeposites";
  constructor(public ReportName: string, public Search: GarageSearchModel) { }
}

export class GetGarageReportFilteredForCustomer {
  static readonly type = "[Garage] GetGarageReportFilteredForCustomer";
  constructor(public ReportName:string, public Search: GarageSearchModel) {}
}

export class GetGarageLocation {
  static readonly type = "[Garage] GetGarageLocation";
  constructor(public Search: GarageSearchModel) {}
}

export class DisposeSearch {
  static readonly type = "[Garage] DisposeSearch";
  constructor() {}
}

export class SetGarageDiscount {
  static readonly type = "[Garage] Set Garage Discount";
  constructor(public Garage: Models.Request<GarageModels.SetGarageDiscountPreviewModel>) { }
}

export class GetGarageDiscount {
  static readonly type = "[Garage] Get Garage Discount";
  constructor(public Garage: Models.RequestModel) { }
}

export class GetGarageDiscountTemplate {
  static readonly type = "[Garage] Get Garage Discount Template";
  constructor(public Garage: Models.Request<number[]>) { }
}
 
export class GetGarageDiscountExcelReport  {
  static readonly type = "[Garage] Get Garage Discount Excel Report";
  constructor(public ReportName: string, public Search: Models.RequestModel) { }
}

export class ImportGarageDiscountList {
  static readonly type = '[Garage] Import Garage Discount';
  constructor(public FileName: string, public Data: any) { }
}

export class SetImportGarageDiscountStatus {
  static readonly type = '[Service] Set Garage Discount Status';
  constructor(public Status: boolean) { }
}

export class SetCommission {
  static readonly type = "[Garage] SetCommission";
  constructor(public Commission: GarageModels.GarageSetComissionModel) {}
}
